import querystring from 'query-string';

import { apiGenerated } from './apiGenerated';

export const enhancedApi = apiGenerated.enhanceEndpoints({
  addTagTypes: ['Project', 'Folder'],
  // paramsSerializer: (params) => {
  //   return qs.stringify(params);
  // },
  endpoints: {
    projectServiceListProjects: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result, error, arg) =>
        result && result.projects
          ? [
              ...result.projects.map(({ name }) => ({
                type: 'Project' as const,
                id: name
              })),
              'Project'
            ]
          : ['Project']
    },
    projectServiceGetProject: {
      // paramsSerializer: (params) => {},
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result, error, arg) =>
        result && result.name
          ? [{ type: 'Project' as const, id: result.name }]
          : ['Project']
    },
    projectServiceCreateProject: {
      invalidatesTags: ['Project']
    },
    projectServiceDeleteProject: {
      invalidatesTags: ['Project']
    },
    projectServiceUpdateProject: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      invalidatesTags: (result, error, arg) => {
        return result && result.name
          ? [{ type: 'Project', id: result?.name }]
          : ['Project'];
      }
    },
    folderServiceListFolders: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result, error, arg) =>
        result && result.folders
          ? [
              ...result.folders.map(({ name }) => ({
                type: 'Folder' as const,
                id: name
              })),
              'Folder'
            ]
          : ['Folder']
    },
    folderServiceGetFolder: {
      // paramsSerializer: (params) => {},
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result, error, arg) =>
        result && result.name
          ? [{ type: 'Folder' as const, id: result.name }]
          : ['Folder']
    },
    folderServiceCreateFolder: {
      invalidatesTags: ['Folder']
    },
    folderServiceBatchCreateFolders: {
      invalidatesTags: ['Folder']
    },
    folderServiceDeleteFolder: {
      invalidatesTags: ['Folder']
    },
    folderServiceUpdateFolder: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      invalidatesTags: (result, error, arg) => {
        return result && result.name
          ? [{ type: 'Folder', id: result?.name }]
          : ['Folder'];
      }
    }
  }
});
